import VideoEmbed from "./project-details/VideoEmbed";
import ProjectInfo from "./project-details/ProjectInfo";
import ProjectDescription from "./project-details/ProjectDescription";
import Header from "./Header";
import Footer from "./Footer";

const Movilib = () => {
  const projectData = {
    videoId: "pzZJXtHmcPE",
    stack: "React.js, Css, TMDB's API, Firebase",
    projectUrl: "https://movilib.web.app/",
    githubUrl: "https://github.com/Druw-Ilg/movilib",
    descriptionKey: "movilibDesc",
  };

  return (
    <>
      <Header />
      <main id="main">
        <section className="portfolio-details">
          <div className="container">
            <div className="row gy-4">
              <VideoEmbed videoId={projectData.videoId} />
              <div className="col-lg-4">
                <ProjectInfo
                  stack={projectData.stack}
                  projectUrl={projectData.projectUrl}
                  githubUrl={projectData.githubUrl}
                />
                <ProjectDescription
                  descriptionKey={projectData.descriptionKey}
                />
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default Movilib;
